import { FC } from 'react'

import { Box, Button, CircularProgress } from '@mui/material'

interface IProps {
  text: string
  textColor?: string
  isLoading: boolean
  alignRight?: boolean
  disabled?: boolean
  color?: any
  sx?: any
  onClick?: any
  icon?: JSX.Element
}

const SubmitButton: FC<IProps> = ({
  text,
  textColor = '#000',
  isLoading,
  alignRight = true,
  disabled,
  color,
  sx,
  onClick,
  icon,
}) => {
  return (
    <Box className="transparent-background" sx={{ marginLeft: alignRight ? 'auto' : 'inherit', ...sx }}>
      <Button
        variant='contained'
        color={color ? color : 'success'}
        sx={{ fontWeight: '500', minHeight: '2.5rem' }}
        fullWidth
        onClick={onClick}
        disabled={disabled || isLoading}
        type='submit' // allows submit on enter
        className='submit-btn'
        disableElevation
      >
        {isLoading ? (
          <CircularProgress variant='indeterminate' size={20} sx={{ color: '#000' }} />
        ) : (
          <>
            {icon && icon}&nbsp;{text}
          </>
        )}
      </Button>
    </Box>
  )
}

export default SubmitButton
